import styled from "styled-components";

export const StyledSection = styled.section`
    display: flex;

    @media (min-width: 734px){
        justify-content: center;
        align-items: center;
    }
`